import type { ReactNode } from 'react';
import { classes, type Space } from '@src/components/layout/space';
import { testIdAttr } from '@src/components/testId';
import './Stack.css';

export type StackAlign = 'start' | 'center' | 'end' | 'stretch';

export interface StackProps {
  children: ReactNode;
  gap?: Space;
  align?: StackAlign;
  /** Stretch to the parent width. */
  wide?: boolean;
  /** Hairline under the stack — a labelled group heading. */
  rule?: 'bottom';
  as?: 'div' | 'section' | 'main' | 'header' | 'footer' | 'nav' | 'ul' | 'ol';
  className?: string;
  testId?: string;
}

export function Stack({
  children,
  gap = 4,
  align = 'stretch',
  wide = false,
  rule,
  as: Tag = 'div',
  className,
  testId,
}: StackProps) {
  return (
    <Tag
      className={classes(
        'stack',
        `stack--gap-${gap}`,
        `stack--align-${align}`,
        wide && 'stack--wide',
        rule === 'bottom' && 'stack--rule-bottom',
        className,
      )}
      {...testIdAttr(testId)}
    >
      {children}
    </Tag>
  );
}